export default "__VITE_ASSET__DbbkvgNS__"